// REACT
import moment = require("moment");
import React = require("react");
import {LoaderTab} from "../../components/Utils/loader/LoaderTab";
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";
import "./AlarmsGlobalMonitor.scss";
import {GlobalMonitorAlarmTypesFilter} from "./components/GlobalMonitorAlarmTypesFilter";
import {GlobalMonitorHeader} from "./components/GlobalMonitorHeader";
import {GlobalMonitorPage} from "./components/GlobalMonitorPage";
import {LoadingPage} from "./components/LoadingPage";
import {
    AlarmSeverity,
    AlarmsGlobalMonitorStatus,
    AlarmStatus,
    JSONAlarmCategoryStatistics,
} from "./data/AlarmsMonitorData";
import {AlarmsMonitorDataMapper} from "./utils/AlarmsMonitorDataMapper";
import {defaultTheme} from "@vebox/etui-themes";
import {ThemeProvider} from "@vebox/etui-system";
import {veboxDefaultTheme} from "../../index";

declare var AppTranslations: AppTranslations;

interface AlarmsGlobalMonitorProps {
    /** String because they must be immutable. */
    filters: string;
    /** Function to open the equipment tab and go to selected alarm. */
    goToEquipmentAlarm: (alarmId: number, equipmentId: number) => any;
    level: any;
    useAsFilterFunction:
        (alarmCategoryId: number, alarmCategoryGuid: string, alarmState: number, alarmSeverity: string, level: any) =>
            void;
}

interface AlarmsGlobalMonitorState {
    status: AlarmsGlobalMonitorStatus;
    currentAlarmStatus: AlarmStatus;
    selectedSeverity: AlarmSeverity;
    data: JSONAlarmCategoryStatistics[];
    openedCategoryFilters: JSONAlarmCategoryStatistics;
    filters: string;
    internalFilters: string;
    /* Global filters values*/
    globalFiltersFromDate: Date;
    globalFiltersToDate: Date;
    globalFiltersSeveritiesToExclude: string[];
    globalFiltersOpened: boolean;
    /* Alarms list opened status*/
    openedCategoryId: number;
    openedSeverityGuid: string;
    openedCategoryGuid: string;
    reload: boolean;
}

export class AlarmsGlobalMonitor extends React.Component<AlarmsGlobalMonitorProps, AlarmsGlobalMonitorState> {
    public static stringFilters(filters: any) {
        return JSON.stringify(filters);
    }

    private static logEnabled: boolean = false;
    private filteredAlarmTypesByCategory: Map<number, number[]> = null;
    private countDown;

    constructor(props: AlarmsGlobalMonitorProps) {
        super(props);
        this.onAlarmStatusChange = this.onAlarmStatusChange.bind(this);
        this.onAlarmTypesFilterApply = this.onAlarmTypesFilterApply.bind(this);
        this.onOpenAlarmTypesFilter = this.onOpenAlarmTypesFilter.bind(this);
        this.export = this.export.bind(this);
        this.closeAlarmTypesFilter = this.closeAlarmTypesFilter.bind(this);
        this.toggleGlobalFilters = this.toggleGlobalFilters.bind(this);
        this.onGlobalFiltersApply = this.onGlobalFiltersApply.bind(this);
        this.onAlarmsListOpen = this.onAlarmsListOpen.bind(this);
        this.onAlarmListClose = this.onAlarmListClose.bind(this);
        this.useAsFilter = this.useAsFilter.bind(this);
        this.state = {
            status: AlarmsGlobalMonitorStatus.LOADING,
            currentAlarmStatus: AlarmStatus.NOT_IN_CHARGE,
            selectedSeverity: null,
            data: null,
            filters: props.filters,
            openedCategoryFilters: null,
            globalFiltersOpened: false,
            globalFiltersFromDate: null,
            globalFiltersToDate: null,
            globalFiltersSeveritiesToExclude: null,
            openedSeverityGuid: null,
            openedCategoryId: null,
            openedCategoryGuid: null,
            internalFilters: props.filters,
            reload: false,
        };
        this.load(props.filters);
    }

    public componentWillUpdate(nextProps: Readonly<AlarmsGlobalMonitorProps>,
                               nextState: Readonly<AlarmsGlobalMonitorState>,
                               nextContext: any) {
        this.log("Component will update");
        if (nextState.filters !== this.state.filters) {
            this.setState(
                {
                    status: AlarmsGlobalMonitorStatus.LOADING,
                    openedCategoryFilters: null,
                    openedCategoryId: null,
                    openedSeverityGuid: null,
                    reload: true,
                },
            );
        }
    }

    public componentDidUpdate(prevProps: Readonly<AlarmsGlobalMonitorProps>,
                              prevState: Readonly<AlarmsGlobalMonitorState>,
                              snapshot?: any): void {
        if (this.state.reload) {
            this.load(this.state.filters);
            this.setState({reload: false});
        }
    }

    public componentDidMount(): void {
        // this.startUpdating();
    }

    public render() {
        let content = (
            <div className={"level-page"}>
                {this.state.status === AlarmsGlobalMonitorStatus.LOADING && <LoadingPage/>}
                {this.state.openedCategoryFilters != null
                && <GlobalMonitorAlarmTypesFilter
                    onApplyFilters={this.onAlarmTypesFilterApply}
                    category={this.state.openedCategoryFilters}
                    excludedAlarmTypes={
                        [...this.filteredAlarmTypesByCategory.get(this.state.openedCategoryFilters.categoryId)]
                    }
                    onCancel={this.closeAlarmTypesFilter}
                />}
                <GlobalMonitorHeader
                    texts={AppTranslations.alarmsMonitor.texts}
                    selectedSeverity={this.state.selectedSeverity}
                    onExportClick={this.export}
                    severities={
                        AlarmsMonitorDataMapper.toAlarmSeveritiesCount(
                            AppTranslations.alarmsMonitor.severities,
                            this.state.data,
                        )
                    }
                    onGlobalFiltersClick={this.toggleGlobalFilters}
                    globalFiltersOpened={this.state.globalFiltersOpened}
                    filtersFromDate={this.state.globalFiltersFromDate}
                    filtersToDate={this.state.globalFiltersToDate}
                    filtersSeveritiesGuid={this.state.globalFiltersSeveritiesToExclude}
                    onFiltersApply={this.onGlobalFiltersApply}
                />
                <GlobalMonitorPage
                    texts={AppTranslations.alarmsMonitor.texts}
                    data={this.state.data}
                    onAlarmElementClick={this.props.goToEquipmentAlarm}
                    selectedSeverity={this.state.selectedSeverity}
                    selectedAlarmStatus={this.state.currentAlarmStatus}
                    filteredAlarmTypesMap={this.filteredAlarmTypesByCategory}
                    onOpenCategoryAlarmTypesFilter={this.onOpenAlarmTypesFilter}
                    alarmStatuses={
                        AlarmsMonitorDataMapper.toAlarmStatusesCount(
                            AppTranslations.alarmsMonitor.statuses,
                            this.state.data,
                            this.state.selectedSeverity,
                        )
                    }
                    onAlarmStatusPageChange={this.onAlarmStatusChange}
                    globalFiltersOpened={this.state.globalFiltersOpened}
                    openedCategoryId={this.state.openedCategoryId}
                    openedSeverityGuid={this.state.openedSeverityGuid}
                    onAlarmListOpen={this.onAlarmsListOpen}
                    onAlarmListClose={this.onAlarmListClose}
                    onFiltersApply={this.onGlobalFiltersApply}
                    filters={this.state.internalFilters}
                    useAsFilter={this.useAsFilter}
                    filtersFromDate={this.state.globalFiltersFromDate}
                    filtersToDate={this.state.globalFiltersToDate}
                    filtersSeveritiesGuid={this.state.globalFiltersSeveritiesToExclude}
                    severities={
                        AlarmsMonitorDataMapper.toAlarmSeveritiesCount(
                            AppTranslations.alarmsMonitor.severities,
                            this.state.data,
                        )
                    }
                    onGlobalFiltersClick={this.toggleGlobalFilters}
                    onExportClick={this.export}
                />
            </div>
        );
        if (this.state.status === AlarmsGlobalMonitorStatus.LOADING && this.state.data == null) {
            content = (
                <div className={"level-page"}>
                    <LoaderTab/>;
                </div>
            );
        } else if (this.state.data != null && this.state.data.length === 0) {
            content = (
                <div className={"level-page"}>
                    <p>{AppTranslations.noDataAvailable}</p>
                </div>
            );
        }
        return (
            <ThemeProvider theme={veboxDefaultTheme}>
                {content}
            </ThemeProvider>
        );
    }

    public destroy() {
        this.stopUpdating();
    }

    public stopUpdating() {
        if (this.countDown) {
            clearInterval(this.countDown);
        }
    }

    public startUpdating() {
        this.countDown = setInterval(() => {
            this.setState({reload: true});
        }, 60000);
    }

    private useAsFilter() {
        this.props.useAsFilterFunction(
            this.state.openedCategoryId,
            this.state.openedCategoryGuid,
            AlarmsMonitorDataMapper.toAlarmStatusCode(this.state.currentAlarmStatus),
            this.state.openedSeverityGuid,
            this.props.level,
        );
    }

    private onAlarmListClose() {
        this.startUpdating();
        this.setState({
                openedCategoryId: null,
                openedSeverityGuid: null,
                openedCategoryGuid: null,
            },
        );
    }

    private onAlarmsListOpen(categoryId: number, severityGuid: string, categoryGuid: string) {
        if (this.state.openedCategoryId !== categoryId
            || this.state.openedSeverityGuid !== severityGuid
            || this.state.openedCategoryGuid !== categoryGuid) {
            this.stopUpdating();
            this.setState({
                    openedCategoryId: categoryId,
                    openedSeverityGuid: severityGuid,
                    openedCategoryGuid: categoryGuid,
                },
            );
        }
    }

    private onGlobalFiltersApply(fromDate: Date, toDate: Date, severitiesToExclude: string[]) {
        this.setState(
            {
                globalFiltersFromDate: fromDate,
                globalFiltersToDate: toDate,
                globalFiltersSeveritiesToExclude: severitiesToExclude,
                status: AlarmsGlobalMonitorStatus.LOADING,
                globalFiltersOpened: false,
                openedCategoryId: null,
                openedSeverityGuid: null,
                openedCategoryGuid: null,
                reload: true,
            },
        );
    }

    private toggleGlobalFilters() {
        this.setState({globalFiltersOpened: !this.state.globalFiltersOpened});
    }

    private closeAlarmTypesFilter() {
        this.setState({openedCategoryFilters: null});
    }

    private onOpenAlarmTypesFilter(category: JSONAlarmCategoryStatistics) {
        this.setState({openedCategoryFilters: category});
    }

    private onAlarmTypesFilterApply(alarmTypes: number[]) {
        this.filteredAlarmTypesByCategory.set(this.state.openedCategoryFilters.categoryId, alarmTypes);
        this.setState({
                openedCategoryFilters: null,
                status: AlarmsGlobalMonitorStatus.LOADING,
                openedSeverityGuid: null,
                openedCategoryId: null,
                openedCategoryGuid: null,
                reload: true,
            },
        );
    }

    private export() {
        const exportListDataRequest: any = {};
        exportListDataRequest.listType = "equipments";
        exportListDataRequest.locationFilters = null;
        exportListDataRequest.equipmentFilters = this.completeFilters(this.state.filters);
        exportListDataRequest.workOrderFilters = null;
        exportListDataRequest.deviceFilters = null;
        Ajax.ajaxRequestForJson(
            {
                url: "registerExportAlarmMonitor",
                data: JSON.stringify(exportListDataRequest),
                type: "POST",
                success: () => {
                    this.log("success export");
                    window.open("exportVeboxAlarmsMonitor", "_self");
                },
                error: (rawData) => {
                    if (rawData != null && rawData.responseText === "OK") {
                        window.open("exportVeboxAlarmsMonitor", "_self");
                    }
                },
            },
        );
    }

    private onAlarmStatusChange(e: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
        // tslint:disable-next-line:radix
        const statusId: number = parseInt(e.currentTarget.dataset.id);
        this.setState({
            currentAlarmStatus: AlarmsMonitorDataMapper.toAlarmsStatusEnum(statusId),
            openedCategoryId: null,
            openedSeverityGuid: null,
        });
    }

    private load(filters: string) {
        this.log("Retrieving alarm categories statistics ");
        const internalFilters = AlarmsGlobalMonitor.stringFilters(this.completeFilters(filters));
        Ajax.ajaxRequestForJson(
            {
                url: "alarm-categories-statistics",
                data: internalFilters,
                type: "POST",
                success: (data: JSONAlarmCategoryStatistics[]) => {
                    if (this.state.filters === filters) {
                        this.log("Success retrieving alarm statistics data");
                        this.log(data);
                        if (this.filteredAlarmTypesByCategory == null) {
                            this.filteredAlarmTypesByCategory = new Map();
                            data.forEach(
                                (element) => {
                                    this.filteredAlarmTypesByCategory.set(element.categoryId, []);
                                },
                            );
                        }
                        this.setState({
                                internalFilters,
                                status: AlarmsGlobalMonitorStatus.LOADED,
                                data,
                            },
                        );
                    } else {
                        this.log("Retrieved alarm statistics but filters changed");
                    }
                },
                error: () => {
                    console.error("Error loading categories statistics");
                },
            },
        );
    }

    private completeFilters(filters: string): any {
        const filtersObj = JSON.parse(filters);
        if (this.filteredAlarmTypesByCategory != null) {
            const alarmTypesToFilter = [];
            const entries = this.filteredAlarmTypesByCategory.entries();
            let element = entries.next();
            while (!element.done) {
                alarmTypesToFilter.push(...element.value[1]);
                element = entries.next();
            }
            filtersObj.globalMonitorFiltersCategory.alarmTypesToExclude = alarmTypesToFilter;
        }
        if (this.state.globalFiltersSeveritiesToExclude != null
            && this.state.globalFiltersSeveritiesToExclude.length > 0) {
            filtersObj.globalMonitorFiltersCategory.severitiesToExclude = this.state.globalFiltersSeveritiesToExclude;
        }
        if (this.state.globalFiltersFromDate != null && this.state.globalFiltersToDate != null) {
            filtersObj.globalMonitorFiltersCategory.fromDate =
                moment(this.state.globalFiltersFromDate).format("YYYY-MM-DDTHH:mm").toString();
            filtersObj.globalMonitorFiltersCategory.toDate =
                moment(this.state.globalFiltersToDate).format("YYYY-MM-DDTHH:mm").toString();
        } else {
            filtersObj.globalMonitorFiltersCategory.fromDate = null;
            filtersObj.globalMonitorFiltersCategory.toDate = null;
        }
        return filtersObj;
    }

    // noinspection JSMethodCanBeStatic
    private log(message: any): void {
        if (AlarmsGlobalMonitor.logEnabled) {
            console.log(message);
        }
    }
}
